import { useDynamicQueryResource } from '@subtile/project-shared';
import document, { type AccountsVars } from '../queries/accountsQuery';
import type { Account } from '../types';

export default (variables: AccountsVars) =>
  useDynamicQueryResource<Account[], AccountsVars>(document, variables);
